import * as React from 'react';

type Props = {
  left: React.ReactNode;
  right?: React.ReactNode;
};

export const ClubProgrammeActionBar: React.FC<Props> = ({ left, right }) => {
  return (
    <div className="cpFooterBar">
      <div className="cpFooterLeft">{left}</div>
      <div className="cpFooterRight">{right}</div>
    </div>
  );
};
